import styled from 'styled-components';
import InputMask from 'react-input-mask';

export const Input = styled(InputMask)`
  width: 100%;
  height: 100%;
  background: ${(props) => props.theme.colors.white};
  color: ${(props) => props.theme.colors.gray};
  font-weight: 400;
  font-size: 22px;
  border-radius: 0px;
  text-align: center;
  border: none;
`;

export const TagError = styled.div`
  position: relative;
  z-index: 20;
  padding: 3px 8px 2px 8px;
  background: ${(props) => props.theme.colors.danger};
  font-weight: 700;
  text-align: center;
  font-size: 14px;
  color: ${(props) => props.theme.colors.white};
  width: max-content;
  border-radius: ${(props) =>
    Number(props.theme.borderRadius)
      ? `${props.theme.borderRadius}px`
      : '16px'};
  top: -39px;
  margin: 0 auto;
`;

export const DivInputContainer = styled.div<{
  error: boolean;
  bottom?: string;
}>`
  display: flex;
  flex-direction: column;
  box-shadow: 0px 4px 4px rgba(36, 36, 36, 0.18);
  border-radius: ${(props) =>
    Number(props.theme.borderRadius)
      ? `${props.theme.borderRadius}px`
      : '16px'};
  align-items: center;
  height: 72px;
  margin-bottom: ${(props) => (props.bottom ? props.bottom : '28px')};
  overflow: hidden;
  border: ${(props) =>
    props.error ? `2px solid ${props.theme.colors.danger}` : 'none'};
`;

export const DivExpiredToken = styled.div<{ error: boolean; bottom?: string }>`
  display: flex;
  flex-direction: row;
  box-shadow: 0px 4px 4px rgba(36, 36, 36, 0.18);
  border-radius: ${(props) =>
    Number(props.theme.borderRadius)
      ? `${props.theme.borderRadius}px`
      : '16px'};
  align-items: center;
  height: 72px;
  background: ${(props) => props.theme.colors.white};
  margin-bottom: ${(props) => (props.bottom ? props.bottom : '28px')};
  overflow: hidden;
  border: ${(props) =>
    props.error ? `2px solid ${props.theme.colors.danger}` : 'none'};

  @media screen and (max-width: 960px) {
    flex-direction: column;
    height: 152px;
  }
`;

export const SpanExpired = styled.span`
  margin: 14px 10px 14px 26px;
  color: ${(props) => props.theme.colors.gray};
  font-size: 16px;
  width: 60%;

  @media screen and (max-width: 960px) {
    margin: 14px 0px 4px 0px;
    width: 80%;
    text-align: center;
  }
`;
export const ButtonExpired = styled.button<{ color: string }>`
  color: ${(props) =>
    props.color === 'primary'
      ? props.theme.colors.white
      : props.theme.colors.primary};
  background: ${(props) =>
    props.color === 'primary'
      ? props.theme.colors.primary
      : props.theme.colors.white};
  font-weight: 700;
  font-size: 16px;
  padding: 0 24px;
  height: 60px;
  border-radius: ${(props) =>
    Number(props.theme.borderRadius)
      ? `${props.theme.borderRadius}px`
      : '16px'};
  box-shadow: 0px 4px 4px rgba(36, 36, 36, 0.2);
  text-transform: uppercase;
  cursor: pointer;
  margin: 6px 6px 6px 0px;
  width: 40%;

  @media screen and (max-width: 960px) {
    width: 68%;
  }
`;
